import {randomId, roundToNearest5k} from '../../../helpers';

export default {
    data() {
        return {
            signing: {},
            signingConflicts: [],
            // missingSigningDirector: false,
        };
    },
    computed: {
        signingAmounts() {
            const amount = this.company.share_capital > 35000 ? this.company.share_capital : 35000;

            return [
                roundToNearest5k(amount * 1.5),
                roundToNearest5k(amount * 2),
                roundToNearest5k(amount * 2.5),
                roundToNearest5k(amount * 3),
                roundToNearest5k(amount * 3.5),
            ];
        },
        signingIds() {
            return Object.keys(this.signing);
        },
        signingRulesCount() {
            return this.signingIds.length;
        },
        canAddNewSigningRight() {
            return this.signingRulesCount < this.directorsCount;
        },
        canDeleteSigningRight() {
            return this.signingRulesCount > 1;
        },
        signingGroupsFlat() {
            const groups = {};

            _.forEach(this.signing, (signingItem) => {
                Object.assign(groups, signingItem.groups);
            });

            return groups;
        },
        signingGroupRightIds() {
            const ids = {};

            _.forEach(this.signing, (signingItem, itemId) => {
                Object.keys(signingItem.groups).forEach((groupId) => {
                    ids[groupId] = itemId;
                });
            });

            return ids;
        },
        signingDirectorIds() {
            let directorIds = [];

            if (!_.isEmpty(this.signing)) {
                _.forEach(this.signing, (signingItem) => {
                    _.forEach(signingItem.groups, (group) => {
                        directorIds = directorIds.concat(group);
                    });
                });
            }

            return _.uniq(directorIds);
        },
        missingSigningDirector() {
            let missingDirector = false;
            _.forEach(this.directorIds, (directorId) => {
                if (!this.signingDirectorIds.includes(directorId)) {
                    missingDirector = true;
                }
            });

            return missingDirector;
        },
    },
    mounted() {
        if (!this.signingRulesCount) {
            this.addSigningStep();
        }
    },
    methods: {
        checkForSigningConflicts() {
            this.signingConflicts = [];
            this.$eventBus.$emit('info-remove', 'signing_conflict');
            const groups = Object.assign({}, this.signingGroupsFlat);

            _.forEach(groups, (group, groupId) => {
                delete groups[groupId];

                _.forEach(groups, (groupToCompare, compareGroupId) => {
                    const diffLength = _.difference(group, groupToCompare).length;
                    const inverseDiffLength = _.difference(groupToCompare, group).length;

                    const signingRightId = this.signingGroupRightIds[groupId];
                    const compareSigningRightId = this.signingGroupRightIds[compareGroupId];

                    const isSameRule = signingRightId === compareSigningRightId;
                    const isHigherRule = this.signingIds.indexOf(compareSigningRightId) > this.signingIds.indexOf(signingRightId);

                    if ((isSameRule && (diffLength === 0 || inverseDiffLength === 0)) || (isHigherRule && inverseDiffLength === 0)) {
                        if (!this.signingConflicts.includes(groupId)) {
                            this.signingConflicts.push(groupId);
                        }
                        if (!this.signingConflicts.includes(compareGroupId)) {
                            this.signingConflicts.push(compareGroupId);
                        }
                    }
                });
            });
        },
        hasConflict(groupId) {
            return this.signingConflicts.includes(groupId);
        },
        checkIfHasConflict(groupId) {
            if (this.hasConflict(groupId)) {
                this.checkForSigningConflicts();
            }
        },
        addSigningStep() {
            const signingItemsCount = Object.keys(this.signing).length;

            if (this.canAddNewSigningRight) {
                const signingItemId = randomId();

                this.$set(this.signing, signingItemId, {
                    amount: this.signingAmounts[signingItemsCount],
                    groups: {}
                });

                this.addSigningGroup(signingItemId);
            }
        },
        signingRemoveConfirm(signingItemId) {
            this.$refs.signingDeleteModal.open(() => {
                this.removeSigningStep(signingItemId);
            })
        },
        removeSigningStep(signingItemId) {
            this.$delete(this.signing, signingItemId);

            this.checkForSigningConflicts();
        },
        addSigningGroup(signingItemId) {
            this.checkForSigningConflicts();
            const groups = this.signing[signingItemId].groups;

            if (Object.keys(groups).length < this.directorsCount) {
                const groupId = randomId();

                this.$set(groups, groupId, []);
                this.addToGroup(signingItemId, groupId);
            }
        },
        removeSigningGroup(signingItemId, groupId) {
            const groups = this.signing[signingItemId].groups;
            if (Object.keys(groups).length > 1) {
                this.$delete(this.signing[signingItemId].groups, groupId);
            }

            this.checkIfHasConflict(groupId);
        },
        addToGroup(signingItemId, groupId) {
            this.checkIfHasConflict(groupId);

            const signingGroup = this.signing[signingItemId].groups[groupId];

            if (signingGroup.length < this.directorsCount) {
                const notSelectedDirectors = _.difference(this.directorIds, signingGroup);
                const directorId = notSelectedDirectors[0];
                signingGroup.push(directorId);
            }
        },
        removeFromGroup(signingItemId, groupId) {
            const signingGroup = this.signing[signingItemId].groups[groupId];

            if (signingGroup.length > 1) {
                signingGroup.pop();
            }

            this.checkIfHasConflict(groupId);
        },
        removeDirectorFromSigningRights(directorId) {
            _.forEach(this.signing, (step, stepId) => {
                _.forEach(step.groups, (group, groupId) => {
                    if (group.includes(directorId)) {
                        if (group.length === 1) {
                            this.$delete(this.signing[stepId].groups, groupId);

                        } else {
                            const index = group.indexOf(directorId);
                            if (index > -1) {
                                group.splice(index, 1);
                            }
                        }
                    }
                });

                if (Object.keys(step.groups).length === 0) {
                    this.$delete(this.signing, stepId);
                }
            });
        },
        showWarningInfo(groupId) {
            return {
                over: () => {
                    if (this.hasConflict(groupId)) {
                        this.$eventBus.$emit('info-show', 'signing_conflict');
                    }
                },
                leave: () => {
                    this.$eventBus.$emit('info-remove', 'signing_conflict');
                },
            }
        }
    }
};
